export default "__VITE_ASSET__C_Q71kO5__"